import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Card, Cell, DeprecatedIcon } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { disableUserHoliday } from 'data/api';
import { reloadPage } from 'libs/utils/window';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getUser } from 'state/session/selectors'; // TODO: Icon should be confirmed or replaced before scaling

import { jsx as _jsx } from "react/jsx-runtime";

const VacationNotification = () => {
  const user = useSelector(getUser);
  const isPortalClosed = useSelector(getIsFeatureSwitchEnabled('portal_closure_stage_3'));
  const {
    0: isLoading,
    1: setIsLoading
  } = useState(false);
  const translate = useTranslate('vacation_notification');

  async function handleClick() {
    if (!user) return;
    setIsLoading(true);
    await disableUserHoliday(user.id);
    reloadPage();
  }

  if (isPortalClosed) return null;
  if (!(user !== null && user !== void 0 && user.is_on_holiday)) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "u-ui-margin-vertical-x-large",
    children: /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsx(Cell, {
        styling: Cell.Styling.Wide,
        prefix: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: "umbrella",
          color: DeprecatedIcon.Color.GreyscaleLevel3
        }),
        body: translate('title'),
        suffix: /*#__PURE__*/_jsx(Button, {
          text: translate('actions.end'),
          onClick: handleClick,
          styling: Button.Styling.Filled,
          size: Button.Size.Medium,
          isLoading: isLoading,
          disabled: isLoading
        }),
        testId: "vacation-notification"
      })
    })
  });
};

export default VacationNotification;